export default __webpack_public_path__ + "SpoqaHanSansNeo-Regular.4af655e.woff";